<template>

    <section>
        <!-- Load More -->
        <div class="row">
            <div class="load-more-container" @click='loadMore()' v-cloak>
                <div class="action-container">
                    <div class="action">
                        <div class="action-icon"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <a class="mx-auto mb-4 load-more-btn" @click='loadMore()' v-cloak>mehr Artikel laden</a>
        </div>

    </section>

</template>

<script>

    export default {
        methods : {
            loadMore(){
                this.$emit('clicked', true);
            }
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .load-more-btn{
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        color: $color-nochvielvor-black;
      &:hover {
        color: $color-nochvielvor-black;
      }
    }
    .load-more-container{
        margin-left: auto;
        margin-right: auto;
        cursor: pointer;
        margin-bottom: 3.25rem;
        @media screen and (min-width: 1200px) {
            margin-bottom: 3.25rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            margin-bottom: 3.25rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            margin-bottom: 3.25rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            margin-bottom: 3.25rem * $factor-2400;
        }
    }

</style>



// WEBPACK FOOTER //
// public/js/components/LoadMore.vue